import React, { useState, useEffect } from 'react';

import { Row, Col } from 'react-bootstrap';

import { format, parseISO } from 'date-fns';
import getResponseErrors from '../../../../utils/getResponseErrors';
import { useToast } from '../../../../hooks/toast';
import api from '../../../../services/api';
import InputFake from '../../../../components/InputFake';

interface IServicoNFDTO {
  SerCodigo: number;
  SerPerCodigo: number;
  SerUsuCodigo: number;
  SerCodigoServico: string;
  SerDescricao: string;
  SerCNAE: string;
  SerAliquota: string;
  SerCodigoTributacao: string;
  SerTipoTributacao: number;
  SerCodigoNBS: string;
  SerIndicOp: string;
  SerIbsClassTrib: string;
  SerIbsSituTrib: string;
  created_at: Date;
  updated_at: Date;
  created_atFormatado: string;
  updated_atFormatado: string;
  usuario: {
    UsuCodigo: number;
    UsuNome: string;
  };
}

type Props = {
  SerPerCodigo?: number;
};

const ServicoNF: React.FC<Props> = ({ SerPerCodigo }) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [servicoNF, setServicoNF] = useState<IServicoNFDTO>();

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IServicoNFDTO>(
          `/serviconf/byperfil/${SerPerCodigo}`,
        );
        if (!response.data) return;

        const responseFormatado = {
          ...response.data,
          created_atFormatado: format(
            parseISO(response.data.created_at.toString()),
            'dd/MM/yyyy HH:mm:ss',
          ),
          updated_atFormatado: format(
            parseISO(response.data.updated_at.toString()),
            'dd/MM/yyyy HH:mm:ss',
          ),
        };
        setServicoNF(responseFormatado);
      } catch (error) {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Não foi possível buscar os dados de serviços',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    }
    if (SerPerCodigo) loadDados();
  }, [SerPerCodigo, addToast]);

  return (
    <>
      {loading && 'carregando...'}
      {!loading && servicoNF && (
        <div className="card p-4 mb-2">
          <h5>Informações Tributárias para Emissão de Nota Fiscal</h5>
          <Row>
            <Col md={12} className="form-group pr-2">
              <InputFake label="Descrção" value={servicoNF.SerDescricao} />
            </Col>
          </Row>
          <Row>
            <Col md={4} className="form-group pr-2">
              <InputFake label="Aliquota" value={servicoNF.SerAliquota} />
            </Col>
            <Col md={4} className="pr-md-2">
              <InputFake
                label="Cod. Serviço"
                value={servicoNF.SerCodigoServico}
              />
            </Col>
            <Col md={4} className="form-group pr-2">
              <InputFake label="CNAE" value={servicoNF.SerCNAE} />
            </Col>
          </Row>

          <Row>
            <Col md={4} className="form-group pr-2">
              <InputFake
                label="TipoTributacao"
                value={servicoNF.SerTipoTributacao}
              />
            </Col>
            <Col md={4} className="pr-md-2">
              <InputFake
                label="Cod. Tributção"
                value={servicoNF.SerCodigoTributacao}
              />
            </Col>
            <Col md={4} className="form-group pr-2">
              <InputFake
                label="Indicador de Operação"
                value={servicoNF.SerIndicOp}
              />
            </Col>
          </Row>

          <Row>
            <Col md={4} className="form-group pr-2">
              <InputFake label="Cod. NBS" value={servicoNF.SerCodigoNBS} />
            </Col>

            <Col md={4} className="pr-md-2">
              <InputFake
                label="Ibs Classificação tributária"
                value={servicoNF.SerIbsClassTrib}
              />
            </Col>
            <Col md={4} className="form-group pr-2">
              <InputFake
                label="Ibs Situação tributária"
                value={servicoNF.SerIbsSituTrib}
              />
            </Col>
          </Row>

          <Row>
            <Col md={5} className="form-group pr-2">
              <InputFake
                label="Ultima Atualização"
                value={servicoNF.updated_atFormatado}
              />
            </Col>

            <Col md={7} className="pr-md-2">
              <InputFake label="Usuário" value={servicoNF.usuario.UsuNome} />
            </Col>
          </Row>
        </div>
      )}

      {!loading && !servicoNF && (
        <div className="card p-4 mb-2">
          <h5>
            Nenhuma Informação Tributária para Emissão de Nota Fiscal cadastrada
          </h5>
        </div>
      )}
    </>
  );
};

export default ServicoNF;
